<template>
  <div v-if="isLocal" class="fixed bg-primary lg:top-0 right-0 bottom-0 w-16 p-4 z-50">
    <WrenchIcon class="h-8 text-foreground" />
  </div>
  <div v-if="isTest" class="fixed lg:top-0 right-0 bottom-0 w-16 p-4 bg-primary/80 z-50">
    <PuzzlePieceIcon class="h-8 text-septenary" />
  </div>
</template>
<script setup>
import { isLocal, isTest } from "@/config";
import { WrenchIcon } from "@heroicons/vue/24/outline";
import { PuzzlePieceIcon } from "@heroicons/vue/24/outline";
</script>
